import React from 'react';
import { useLayer } from 'react-laag';
import { Link } from 'react-router';

// icons
import SettingsIcon from '@assets/icons/settings.svg';
import CardIcon from '@assets/icons/card.svg';
import HelpIcon from '@assets/icons/help-circle-contained.svg';
import MessageIcon from '@assets/icons/message-circle.svg';
import LogoutIcon from '@assets/icons/logout.svg';

// styles
import css from './styles.module.css';

interface IProps {
  toggleComponent: React.ReactNode;
  trialPeriod?: boolean;
}

function AccountMenu({ toggleComponent, trialPeriod = false }: IProps) {
  const [isOpen, setOpen] = React.useState(false);

  function close() {
    setOpen(false);
  }

  const { renderLayer, triggerProps, layerProps } = useLayer({
    isOpen,
    onOutsideClick: close, // close the menu when the user clicks outside
    onDisappear: close, // close the menu when the menu gets scrolled out of sight
    overflowContainer: false, // keep the menu positioned inside the container
    auto: true, // automatically find the best placement
    placement: 'bottom-end', // we prefer to place the menu "top-end"
    triggerOffset: 12, // keep some distance to the trigger
    containerOffset: 16, // give the menu some room to breath relative to the container
    arrowOffset: 16, // let the arrow have some room to breath also
  });

  const handleContainerClick = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        {...triggerProps}
        onClick={() => setOpen(!isOpen)}
        className={css.toggleButton}
      >
        {toggleComponent}
      </button>
      {renderLayer(
        isOpen && (
          <div
            className={css.root}
            {...layerProps}
            onClick={handleContainerClick}
          >
            <div className={css.innerWrapper}>
              <Link to="/account/profile" className={css.menuItem}>
                <img
                  className={css.menuIcon}
                  src={SettingsIcon}
                  alt=""
                  width="24"
                  height="24"
                />
                Profile settings
              </Link>

              {!trialPeriod && (
                <Link to="/account/plan" className={css.menuItem}>
                  <img
                    className={css.menuIcon}
                    src={CardIcon}
                    alt=""
                    width="24"
                    height="24"
                  />
                  Plan details
                </Link>
              )}

              <Link to="/account/help" className={css.menuItem}>
                <img
                  className={css.menuIcon}
                  src={HelpIcon}
                  alt=""
                  width="24"
                  height="24"
                />
                FAQ
              </Link>

              <Link to="/account/contact-us" className={css.menuItem}>
                <img
                  className={css.menuIcon}
                  src={MessageIcon}
                  alt=""
                  width="24"
                  height="24"
                />
                Contact us
              </Link>

              <a href="/logout" className={css.menuItem}>
                <img
                  className={css.menuIcon}
                  src={LogoutIcon}
                  alt=""
                  width="24"
                  height="24"
                />
                Log Out
              </a>
            </div>
          </div>
        ),
      )}
    </>
  );
}

export default AccountMenu;
